import { useEffect } from "react";
import Resume from "../settings/resume.json";

export const HelmetMeta = () => {

    useEffect(() => {
        document.title = `${Resume.basics.name} | ${Resume.basics.location.city}, ${Resume.basics.location.country}`;
    }, []);

    return null;
};